import { mainCanvasSize } from "../../lib/littlejs.esm";
/**
 * Calculates the negative offset we need to add to the bitmap texts to have them centered
 * Used as offset here : LJS.mainCanvasSize.x / 2 - offset
 * @param text - The text to display
 * @param size - The bitmap font size used (1 being 8px)
 * @returns number - The x position to start the text
 */
function getCenterTextPos(text, size) {
    return (mainCanvasSize.x / 2) - ((text.length / 2 * size) * 8);
}
export { getCenterTextPos };
